import type { CSSProperties, ReactNode } from "react";
import type { DataElScope } from "@/utils/dataEl";
import { CreferenceInlineContent } from "./CreferenceInlineContent";
import type { CreferenceInteraction } from "./creferenceInteractionTypes";
import type { CreferenceResolvedEntity } from "./useCreferenceResolvedEntity";

export interface CreferenceInlineReferenceProps {
  dataElScope: DataElScope;
  className?: string;
  disabled: boolean;
  interaction: CreferenceInteraction;
  leading: ReactNode;
  linkedLabelTextStyle: CSSProperties;
  resolvedEntity: CreferenceResolvedEntity;
  style?: CSSProperties;
}

export function CreferenceInlineReference({
  dataElScope,
  className,
  disabled,
  interaction,
  leading,
  linkedLabelTextStyle,
  resolvedEntity,
  style,
}: CreferenceInlineReferenceProps): ReactNode {
  return (
    <CreferenceInlineContent
      dataElScope={dataElScope}
      canClick={interaction.canClick}
      className={className}
      disabled={disabled}
      isLoading={resolvedEntity.isLoading}
      isUnresolved={resolvedEntity.isUnresolved}
      label={resolvedEntity.label}
      labelSuffix={resolvedEntity.labelSuffix}
      leading={leading}
      linkedLabelTextStyle={linkedLabelTextStyle}
      onClick={interaction.handleClick}
      rootRef={interaction.setHintAnchorElement}
      style={style}
    />
  );
}
